/* ========================== */
/*          PRODUCT           */
/* ========================== */

swiperProduct = {
    main: null,
    thumbs: null,

    updateVariantMedia: function (mediaId) {
        if (!this.main) return;

        var galleries = document.querySelectorAll(
            ".swiper--product-gallery, .swiper--product-gallery--thumbs"
        );

        galleries.forEach(function (gallery) {
            gallery.querySelectorAll(".swiper-slide--variant-media").forEach(function (slide) {
                slide.classList.add("swiper-slide--hidden");
            });

            if (mediaId) {
                var activeSlide = gallery.querySelector(
                    '.swiper-slide[data-media="' + mediaId + '"]'
                );
                if (activeSlide) {
                    activeSlide.classList.remove("swiper-slide--hidden");
                }
            }
        });

        this.main.update();
        this.thumbs.update();

        if (mediaId) {
            var mainGallery = document.querySelector(".swiper--product-gallery");
            var targetSlide = mainGallery
                ? mainGallery.querySelector('.swiper-slide[data-media="' + mediaId + '"]')
                : null;

            if (targetSlide && !targetSlide.classList.contains("swiper-slide--hidden")) {
                var slideIndex = Array.prototype.indexOf.call(
                    targetSlide.parentElement.children,
                    targetSlide
                );
                if (slideIndex >= 0) {
                    this.main.slideTo(slideIndex);
                }
            }
        }
    },

    init: function () {
        var swiperThumbs = new Swiper(".swiper--product-gallery--thumbs", {
            slidesPerView: "auto",
            spaceBetween: 0,
            freeMode: true,
            allowTouchMove: false,
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: ".swiper--product-gallery--thumbs .swiper-btn--next",
                prevEl: ".swiper--product-gallery--thumbs .swiper-btn--prev",
            },
            on: {  // Arreglar l'error on no canvia el slide si no fas dos clics
                touchEnd: function (s, e) {
                    let range = 5;
                    let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY
                        - s.touches.startY
                    if (diff < range || diff > -range) s.allowClick = true;
                }
            },
        });

        this.thumbs = swiperThumbs;

        this.main = new Swiper(".swiper--product-gallery", {
            effect: "fade",
            slidesPerView: "auto",
            mousewheel: {
                invert: false,
                forceToAxis: true
            },
            thumbs: {
                swiper: swiperThumbs,
            }
        });
    }
};

openVariations = {
    init: function () {
        $(".attributes__title").on("click", function () {
            $(this).closest(".attributes-values").toggleClass("open");
        });
        $("body").on("click", function (e) {
            if (!$(e.target).closest('.attributes__title, .attributes-values').length) {
                $(".attributes-values").removeClass("open");

            }
        })
    }
};

mobileAccordion = {
    init: function () {
        $(".mobile-acordion__label").on("click", function () {
            if ($(window).width() <= 991) {
                var item = $(this).closest(".mobile-acordion");

                if (!item.hasClass("open")) {
                    item.addClass("open");
                    item.find(".mobile-acordion__body").height(item.find(".mobile-acordion__body--inner").outerHeight());
                } else {
                    item.removeClass("open");
                    item.find(".mobile-acordion__body").height(0);
                }
            }
        });
    }
};

$(document).ready(function () {
    mobileAccordion.init();
    openVariations.init();
    swiperProduct.init();
});